import { createSelector } from 'reselect'

export const getCommissionData = createSelector(
  (state: App.State) => state.checkout.commissionData,
  items => items,
)
